/**
 * Chybová hláška z BE pro obsluhu.
 *
 * Axios chyba JE instance Error, takže `err.message` je vždy jen anglický
 * technický text („Request failed with status code 500"). Použitelná česká
 * hláška je v těle odpovědi (`ApiError.message` z ApiExceptionHandler) —
 * např. „Generování TREASURY zatím není podporováno…". Fallback je obecný
 * text volajícího.
 */
export function apiError(err: unknown, fallback: string): string {
  const data = (err as any)?.response?.data
  if (typeof data === 'string' && data.trim()) return data
  const message = data?.message
  if (typeof message === 'string' && message.trim()) return message
  const error = data?.error
  if (typeof error === 'string' && error.trim()) return error
  return fallback
}
